<template>
  <modal :open="internalOpen">
    <template #header>
      <modal-header variant="cross" @cancel="internalOpen = false">
        <h1>{{ $t("pages.modal.resetPassword.title") }}</h1>
      </modal-header>
    </template>

    <div class="text-center mt-17.5">
      <h2 class="whitespace-nowrap">
        {{ $t("pages.modal.resetPassword.description") }}
      </h2>
      <span class="block mt-3">
        {{ $t("pages.modal.resetPassword.helpText") }}
      </span>
      <custom-button
        variant="primary"
        class="mt-15"
        :busy="loading"
        @click="resetPassword"
      >
        {{ $t("pages.modal.resetPassword.buttonText") }}
      </custom-button>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import Modal from '@utils/Modal/Modal.vue';
import { useNotify } from '@utils/notifications';
import { useFetchAction } from '@hooks/fetch';
import type { User } from '@/entities/Entities';

interface Props {
  open: boolean;
  user: User;
}

const emit = defineEmits(['update:open']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

const { t } = useI18n();

const notify = useNotify();

const [exec, { loading }] = useFetchAction();

const resetPassword = async () => {
  try {
    await exec('/users/ask-reset-password', {
      method: 'POST',
      body: {
        email: props.user.email,
      },
    });

    notify?.({
      variant: 'success',
      title: t('pages.modal.resetPassword.saveSuccess'),
    });

    internalOpen.value = false;
  } catch (e) {
    notify?.({
      variant: 'error',
      title: t('pages.modal.resetPassword.saveError'),
    });
  }
};
</script>

<style lang="scss" scoped></style>
